<template>
  <div class="table-th">
    <template v-if="header.id === 'title'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span>Название</span>

            <div
              class="column-filter-icon"
              @click.stop="
                showFilter === 'title' ? $emit('set-show-filter', 'none') : $emit('set-show-filter', 'title')
              "
            >
              <icon-filter :color="filterTitleSelected.length > 0 ? 'green' : 'grey'" />
            </div>

            <transition name="slidetop">
              <vtfilter
                v-if="showFilter === 'title'"
                class="th_filter"
                type="text"
                :text-value="filterTitleSelected"
                @apply="applyFilter"
                @input="setTempTitle"
                @clear="clearTitle"
                @cancel="$emit('set-show-filter', 'none')"
              />
            </transition>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'region'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span>Регион</span>

            <div
              class="column-filter-icon"
              @click.stop="
                showFilter === 'region' ? $emit('set-show-filter', 'none') : $emit('set-show-filter', 'region')
              "
            >
              <icon-filter :color="filterRegionSelected.length > 0 ? 'green' : 'grey'" />
            </div>

            <transition name="slidetop">
              <vtfilter
                v-if="showFilter === 'region'"
                class="th_filter"
                type="text"
                :text-value="filterRegionSelected"
                @apply="applyFilter"
                @input="setTempRegion"
                @clear="clearRegion"
                @cancel="$emit('set-show-filter', 'none')"
              />
            </transition>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'responses_count'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span>Откликов</span>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'manager_id'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span>{{ $tr('common.list.creator') }}</span>

            <div
              v-if="filterAuthor && filterAuthor.length > 0"
              class="column-filter-icon"
              @click.stop="
                showFilter === 'manager_id' ? $emit('set-show-filter', 'none') : $emit('set-show-filter', 'manager_id')
              "
            >
              <icon-filter :color="filterAuthorSelected.length > 0 ? 'green' : 'grey'" />
            </div>

            <transition name="slidetop">
              <vcv-table-filter
                v-if="showFilter === 'manager_id'"
                type="list"
                :list="filterAuthor"
                :pre-selected="filterAuthorSelected"
                show-search
                @apply="applyManagersFilter($event)"
                @cancel="$emit('set-show-filter', 'none')"
                @clear="applyManagersFilter([])"
              />
            </transition>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'row-action'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span>Связать</span>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      {{ header.name }}
    </template>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import VcvTableFilter from '@/components_new/complex/VcvTableFilter';

export default {
  components: {
    VcvTableFilter
  },

  props: {
    header: {
      type: [Array, Object],
      default: () => []
    },

    showFilter: {
      type: String,
      default: 'none'
    },

    filter: {
      type: [Array, Object],
      default: () => []
    },

    filterTitleSelected: {
      type: String,
      default: ''
    },

    filterRegionSelected: {
      type: String,
      default: ''
    },

    filterAuthor: {
      type: Array,
      default: () => []
    },

    filterAuthorSelected: {
      type: Array,
      default: () => []
    },

    sorting: {
      type: Object,
      default: () => ({ name: 'title', order: 'desc' })
    }
  },

  methods: {
    ...mapMutations('integrationsHrm', ['SET_FILTER_PROPERTY']),

    setTempTitle(value) {
      this.$emit('set-temp-title', value);
    },

    setTempRegion(value) {
      this.$emit('set-temp-region', value);
    },

    setTempAuthor(value) {
      this.$emit('set-temp-author', value.result);
    },

    clearTitle() {
      this.$emit('set-temp-title', '');
      this.applyFilter();
    },

    clearRegion() {
      this.$emit('set-temp-region', '');
      this.applyFilter();
    },

    clearAuthor() {
      this.$emit('set-temp-author', []);
      this.applyFilter();
    },

    applyFilter() {
      this.$emit('set-show-filter', 'none');
      this.$emit('apply-filter');
    },

    applyManagersFilter(managersArray) {
      this.SET_FILTER_PROPERTY({ property: 'author', value: managersArray });
      this.$emit('set-show-filter', 'none');
      this.$emit('apply-filter');
    }
  }
};
</script>

<style lang="scss" scoped>
.column-filter {
  display: flex;
  align-items: center;
}

.column-filter-icon {
  margin-left: 4px;
  display: flex;
  align-items: center;
}
</style>
